export default __webpack_public_path__ + "static/media/17-Windswept.920c9d68.jpeg";